import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/font.css'
import App from './App.vue'
import router from './router'
import i18n from './lang/index'
import axios from 'axios'

Vue.use(ElementUI)
Vue.config.productionTip = false
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
})
Vue.prototype.$axios = axios
new Vue({
  i18n,
  router,
  render: h => h(App)
}).$mount('#app')
